import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function PhilosophyPage() {
  return (
    <div className="min-h-screen pt-32 pb-24 px-6 md:px-12" data-testid="philosophy-page">
      <SEO title="Our Philosophy" description="We don't believe a shirt changes a life. People do. Sometimes all they need is a reminder." />
      <div className="max-w-[900px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="font-mono text-[#FFD700] text-sm tracking-[0.3em] mb-2">OUR PHILOSOPHY</p>
          <h1 className="font-heading text-5xl md:text-7xl tracking-tight uppercase leading-[0.9]">
            OUR <span className="text-[#FFD700]">PHILOSOPHY</span>
          </h1>
        </motion.div>

        <div className="space-y-10">
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }}
            className="text-xl md:text-2xl text-white font-medium leading-relaxed">
            We don't believe a shirt changes a life.<br />
            People do.
          </motion.p>

          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.25 }}
            className="text-[#C0C0C0] text-base md:text-lg leading-relaxed">
            Sometimes all they need is a reminder.
          </motion.p>

          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35 }}
            className="text-[#C0C0C0] text-base md:text-lg leading-relaxed">
            3T was created around a simple belief:<br />
            <span className="text-white font-medium">Ideas deserve to be remembered.</span>
          </motion.p>

          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.45 }}
            className="text-[#C0C0C0] text-base md:text-lg leading-relaxed">
            Every design begins with a thought.<br />
            Every shirt carries that thought into everyday life.
          </motion.p>

          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.55 }}
            className="text-[#C0C0C0] text-base md:text-lg leading-relaxed">
            We're not here to tell people how to live.<br />
            We're simply sharing another way to look at life.
          </motion.p>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.65 }}
            className="border-l-4 border-[#FFD700] pl-6 py-4 mt-16">
            <p className="font-heading text-xl md:text-2xl leading-snug tracking-wide uppercase">
              If that idea resonates with you...<br />
              Welcome to <span className="text-[#FFD700]">3T</span>.
            </p>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.75 }}
            className="mt-12">
            <Link to="/shop" className="btn-primary inline-flex items-center gap-3">
              Choose Your Reminder
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
